<template>
  <v-layout column>
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-chip>
          <v-checkbox hide-details :label="$t('HOME_CHECKBOX_MY_MAILINGS')" v-model="showMine"></v-checkbox>
        </v-chip>
        <v-chip>
          <v-checkbox hide-details :label="$t('HOME_CHECKBOX_OTHER_MAILINGS')" v-model="showOther"></v-checkbox>
        </v-chip>
        <v-chip>
          <v-checkbox hide-details :label="$t('HOME_CHECKBOX_OLD_MAILINGS')" v-model="showOld"></v-checkbox>
        </v-chip>
        <!-- <v-chip> -->
          <v-btn icon rounded outline- :color="!showDateless ? 'grey lighten-2' : 'primary lighten-2'" @click="showDateless = !showDateless" :title="$t(!showDateless ? 'HOME_MAILINGS_DISPATCH_NOTE' : 'HOME_MAILINGS_ALL_NOTE')">
            <v-icon>mdi-information-variant</v-icon>
          </v-btn>
        <!-- </v-chip> -->
      </v-toolbar-items>
    </v-toolbar>

    <v-card>
      <v-card-title primary-title>
        <h2>{{ $t('DASHBOARD_BT_MAILINGS') }}</h2>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :headers="headers"
          :items="filteredMailings"
          class="elevation-1"
          :options.sync="options"
          must-sort
          hide-default-footer
          @click:row="onActive"
          @dblclick:row="onMailing"
          @keyup.up="onActive(props.index-1)"
          @keyup.down="onActive(props.index+1)"
          @keyup.13="onMailing"
          :items-per-page="30"
          :search="search"
          :custom-filter="filterOnlyCapsText"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
            ></v-text-field>
          </template>

          <template v-slot:item="props">
            <tr
              :key="props.index"
              :active="props.selected"
              :data-index="props.index"
              :class="activeIndex==props.index ? 'active' : ''"
              tabindex="-1"
              @click="onActive(props.index)"
              @dblclick="onMailing"
              style="user-select: none;"
              @keyup.up="onActive(props.index-1)"
              @keyup.down="onActive(props.index+1)"
              @keyup.13="onMailing"
            >
             <td>
                <v-icon v-if="props.item.status==='open'">mdi-email-open</v-icon>
                <v-icon v-if="props.item.status==='released'">mdi-email-check</v-icon>
                <v-icon v-if="props.item.status==='sending'">mdi-email-send</v-icon>
                <v-icon v-if="props.item.status==='closed'">mdi-email</v-icon>
              </td>
              <td class="text-xs"><Progress v-if="props.item.status==='sending'" :num_sent="props.item.num_sent" :num_total="props.item.num_total" /><template v-else>{{ mailingStatusNames[props.item.status] }}</template></td>
              <td class="text-xs">{{ props.item.date ? props.item.date : '-' }}</td>
              <td class="text-xs"><router-link :to="`mailing/${props.item.id}/${encodeURIComponent(props.item.mailing)}`">{{ props.item.mailing }}</router-link></td>
              <td class="text-xs">{{ props.item.owner }}</td>
              <td class="text-xs">{{ props.item.campaign }}</td>
              <td class="text-xs">
                <a :href="props.item.statsUrl" target="_blank">
                  <v-icon v-if="props.item.status==='closed'">mdi-chart-bar</v-icon>
                </a>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <td :colspan="headers.length" class="text-xs-right">
              {{ filteredMailings.length }} / {{ mailings.length }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Mailing from "../services/Mailing";
import Progress from "./common/Progress";
const ALLOWED_ROWS = 30

export default {
  name: 'Mailings',
  components: {
    Progress,
  },
  props: ['refToolbar', 'flag'],
  data() {
    return {
      search: '',
      autoUpdate: null,
      activeIndex: 0,
      activeMailing: null,
      options: {
        'sort-by': 'dateSort',
        'descending': true,
      },
      showMine: true,
      showOther: true,
      showOld: false,
      showDateless: false,
      pollingTimeout: 0,
      pollingState: false,
    }
  },
  computed: {
    ...mapGetters(['data', 'settings', 'campaignEntries', 'sendingMailings']),
    headers() {
// console.log('computed headers')
      return [
        { text: '', value: 'icon', sortable: false, width: '1%' },
        { text: this.$t('HOME_TABLE_PROGRESS'), value: 'status' },
        { text: this.$t('HOME_TABLE_DATE'), value: 'dateSort' },
        { text: this.$t('HOME_TABLE_MAILING'), value: 'mailing' },
        { text: this.$t('HOME_TABLE_RESPONSIBLE'), value: 'owner' },
        { text: this.$t('HOME_TABLE_CAMPAIGN'), value: 'campaign' },
        { text: '', value: 'chart', sortable: true, width: '1%' }
      ]
    },
    mailings() {  
      let mailings = this.campaignEntries
      // .filter(a => a.type === 'mailing')
      .map(a => {
        let datetime = a.type === 'print' ? a.action_datetime || '' : a.dispatch_datetime || ''
        let date = datetime.substr(0, 8)
        return {
          ...a,
          icon: '',
          id: a.id,
          status: a.status,
          // date: date ? `${date.substr(0,4)}-${date.substr(4,2)}-${date.substr(6,2)}` : '-', // yyyy-MM-dd
          // date: date ? `${date.substr(6,2)}/${date.substr(4,2)}/${date.substr(2,2)}` : '-', // dd.MM.yyyy
          date: date ? `${date.substr(6,2)}/${date.substr(4,2)}/${date.substr(2,2)}` : null, // dd.MM.yyyy
          dateSort: datetime,
          mailing: a.name || a.title,
          owner: a.user_name,
          campaign: a.campaign_name,
          statsUrl: `${this.data.nl_base_link}&access_key=${a.access_key}&id=${a.id}`,
          chart: a.status=='closed'
        }
      })
      .filter(a => this.showDateless || a.date)
      .sort((a, b) => ('' + b.dateSort).localeCompare('' + a.dateSort))
      if (this.showOld) {
        return mailings
      } else {
        return mailings.slice(0, ALLOWED_ROWS)
      }
    },
    filteredMailings() {
      return this.mailings
      .filter(a => this.showMine && a.user_id === this.settings.account.id || this.showOther && a.user_id !== this.settings.account.id)
      // .filter(a => this.showDateless || a.date)
    },
    mailingStatusNames() {
      return {
        'closed': this.$t('MAILING_STATUS_CLOSED'),
        'sending': this.$t('MAILING_STATUS_SENDING'),
        'released': this.$t('MAILING_STATUS_RELEASED'),
        'open': this.$t('MAILING_STATUS_OPEN'),
      }
    },
  },
  watch: {
    activeIndex(index) {
      this.focusTR(index)
    },
    showMine(newVal) {
      if (!newVal) {
        this.showOther = true
      }
    },
    showOther(newVal) {
      if (!newVal) {
        this.showMine = true
      }
    },
    filteredMailings() {
      this.focusTR(0)
      this.options.itemsPerPage = this.filteredMailings.length
    },
    flag(val) {
      if (val === 'debug1') {
        this.$store.commit('setDebug', true)
      }
      if (val === 'debug0') {
        this.$store.commit('setDebug', false)
      }
    },
    sendingMailings(sending) {
      let hasCurrent = false;
      sending.currMailings.forEach( m => {
        // console.log('curr_mailing: ', m)
        this.campaignEntries.filter(ce => ce.id == m._attributes.mailing_id).forEach( entry => {
          Vue.set(entry, 'status', 'sending');
          Vue.set(entry, 'num_sent', m._attributes.num_sent);
          Vue.set(entry, 'num_total', m._attributes.num_total);
        })
        if (this.pollingTimeout !== 5000) {
          this.pollingTimeout = 5000
          this.pollingState = true
        }
        hasCurrent = true
      })
      sending.lastMailings.forEach( m => {
        // console.log('last_mailing: ', m)
        this.campaignEntries.filter(ce => ce.id == m._attributes.mailing_id).forEach( entry => {
          Vue.set(entry, 'status', 'closed');
        })
        if (this.pollingTimeout !== 60000 && !hasCurrent) {
          this.pollingTimeout = 60000
          this.pollingState = true
        }
      })
      sending.upcoming.forEach( m => {
        // console.log('last_mailing: ', m)
        this.campaignEntries.filter(ce => ce.id == m._attributes.mailing_id).forEach( entry => {
          Vue.set(entry, 'status', 'released');
        })
        if (this.pollingTimeout !== 60000 && !hasCurrent) {
          this.pollingTimeout = 60000
          this.pollingState = true
        }
      })
      // if there is a sending change (see above) switch to sending
      if (this.pollingState) {
        this.runMailPolling(this.pollingTimeout)
        this.pollingState = false
      }
    },
  },

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    if (this.flag === 'debug1') {
      this.$store.commit('setDebug', true)
    }
    if (this.flag === 'debug0') {
      this.$store.commit('setDebug', false)
    }
    this.pollingTimeout = 60000;
    new Mailing(this.$api).list_sending_mailings();
    this.runMailPolling(this.pollingTimeout);
  },
  methods: {
    runMailPolling(msecs) {
      if (this.autoUpdate) {
        clearInterval(this.autoUpdate)
      }
      this.autoUpdate = setInterval( () => {
        new Mailing(this.$api).list_sending_mailings()
      }, msecs)
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },

    focusTR(index){
      let selected = document.querySelector('[data-index="'+index+'"]')
      if (selected) {
        selected.focus()
      }
    },

    onActive(index) {
      if (index !== null && index >= 0 && index <= this.filteredMailings.length - 1) {
        this.activeIndex = index
        this.activeMailing = this.filteredMailings[this.activeIndex]
      }
    },

    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    },

    onMailing(){
      this.$router.push({ name: 'mailing', params: { id: this.activeMailing.id, title: this.activeMailing.label }, hash: this.getNewHash()})  
    },
  },
  beforeDestroy() {
    clearInterval(this.autoUpdate)
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style scoped lang="scss">
table.v-table tbody td,
table.v-table tbody th {
  height: 2em;
}
</style>
